import _ from 'underscore';
import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Slider from 'components/sliders/BaseSlider';

import Tag from 'components/Tag';

const Tabs = memo(
	({ list, active, onClick, className, sliderParams, theme }) => (
		<Slider
			params={{ navigation: false, ...sliderParams }}
			className={className}
		>
			{_(list).map(({ title, name, url }) => (
				<Tag
					key={url || name}
					title={title}
					active={active && name === active}
					onClick={() => onClick(name)}
					url={url}
					theme={theme}
				/>
			))}
		</Slider>
	)
);

Tabs.propTypes = {
	list: PropTypes.array.isRequired,
	active: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
	theme: PropTypes.string,
	sliderParams: PropTypes.object
};

Tabs.defaultProps = {
	onClick: _.noop,
	theme: 'contrast',
	sliderParams: {}
};

export default Tabs;
